{
  "name": "@deighton/shell-app",
  "version": "0.1.0",
  "private": true,
  "scripts": {
    "build": "ng build",
    "postbuild": "npm run clean:index",
    "build:azure": "rushx build --configuration=azure && npm run postbuild",
    "build:deightonnation": "rushx build --configuration=deightonnation && npm run postbuild",
    "build:develop": "rushx build --configuration=development && npm run postbuild",
    "build:local": "rushx build --configuration=local && npm run postbuild",
    "build:prod": "rushx build --configuration=production && npm run postbuild",
    "clean:index": "rm -f dist/shell-app/index.html",
    "deploy": "swa deploy ./dist/shell-app --env production",
    "preinstall": "npx only-allow pnpm",
    "lint": "eslint .",
    "lint:fix": "eslint . --fix",
    "ng": "ng",
    "prettier": "prettier --config ../../.prettierrc.js --ignore-path ../../.prettierignore '**/*.{ts,html,json,scss}' --check",
    "prettier:fix": "prettier --config ../../.prettierrc.js --ignore-path ../../.prettierignore '**/*.{ts,html,json,scss}' --write",
    "start": "ng serve",
    "start:deightonnation": "rushx start --configuration=deightonnation",
    "start:develop": "rushx start --configuration=development",
    "start:local": "rushx start --configuration=local",
    "start:prod": "rushx start --configuration=production",
    "test": "jest",
    "test:ci": "jest --verbose=false --coverage",
    "test:coverage": "jest --coverage",
    "watch": "ng build --watch",
    "watch:deightonnation": "rushx watch --configuration=deightonnation",
    "watch:develop": "rushx watch --configuration=development",
    "watch:local": "rushx watch --configuration=local",
    "watch:prod": "rushx watch --configuration=production"
  },
  "dependencies": {
    "@angular/cdk": "^22.2.0",
    "@angular/common": "^22.2.0",
    "@angular/compiler": "^22.2.0",
    "@angular/core": "^22.2.0",
    "@angular/elements": "^22.2.0",
    "@angular/forms": "^22.2.0",
    "@angular/localize": "^22.2.0",
    "@angular/material": "^22.2.0",
    "@angular/platform-browser": "^22.2.0",
    "@angular/platform-browser-dynamic": "^22.2.0",
    "@angular/router": "^22.2.0",
    "@apollo/client": "^4.3.1",
    "@deighton/ai-homepage": "workspace:*",
    "@deighton/car": "workspace:*",
    "@deighton/integration-hub": "workspace:*",
    "@deighton/shared-ui": "workspace:*",
    "@deighton/system-settings": "workspace:*",
    "@egjs/hammerjs": "^2.0.0",
    "@jsverse/transloco": "~8.4.0",
    "@jsverse/utils": "~1.0.0-beta.6",
    "@mapbox/sphericalmercator": "^2.0.2",
    "@material-symbols/metadata": "~0.45.5",
    "@ngrx/effects": "~22.0.1",
    "@ngrx/signals": "~22.0.1",
    "@ngrx/store": "~22.0.1",
    "@ngrx/store-devtools": "~22.0.1",
    "@okta/okta-angular": "~8.0.0",
    "@okta/okta-auth-js": "~8.0.1",
    "@progress/kendo-angular-buttons": "~24.2.2",
    "@progress/kendo-angular-charts": "~24.2.2",
    "@progress/kendo-angular-common": "~24.2.2",
    "@progress/kendo-angular-conversational-ui": "24.2.2",
    "@progress/kendo-angular-dateinputs": "~24.2.2",
    "@progress/kendo-angular-dialog": "~24.2.2",
    "@progress/kendo-angular-dropdowns": "~24.2.2",
    "@progress/kendo-angular-excel-export": "~24.2.2",
    "@progress/kendo-angular-grid": "~24.2.2",
    "@progress/kendo-angular-icons": "~24.2.2",
    "@progress/kendo-angular-indicators": "~24.2.2",
    "@progress/kendo-angular-inputs": "~24.2.2",
    "@progress/kendo-angular-intl": "~24.2.2",
    "@progress/kendo-angular-l10n": "~24.2.2",
    "@progress/kendo-angular-label": "~24.2.2",
    "@progress/kendo-angular-layout": "~24.2.2",
    "@progress/kendo-angular-menu": "24.2.2",
    "@progress/kendo-angular-navigation": "~24.2.2",
    "@progress/kendo-angular-pager": "~24.2.2",
    "@progress/kendo-angular-pdf-export": "~24.2.2",
    "@progress/kendo-angular-popup": "~24.2.2",
    "@progress/kendo-angular-progressbar": "~24.2.2",
    "@progress/kendo-angular-scrollview": "~24.2.2",
    "@progress/kendo-angular-spreadsheet": "24.2.2",
    "@progress/kendo-angular-toolbar": "24.2.2",
    "@progress/kendo-angular-treeview": "~24.2.2",
    "@progress/kendo-angular-upload": "~24.2.2",
    "@progress/kendo-angular-utils": "~24.2.2",
    "@progress/kendo-common": "~1.1.1",
    "@progress/kendo-data-query": "~1.7.2",
    "@progress/kendo-drawing": "~1.25.6",
    "@progress/kendo-licensing": "~1.11.2",
    "@progress/kendo-svg-icons": "^5.4.0",
    "@progress/kendo-theme-core": "~14.5.0",
    "@progress/kendo-theme-default": "~14.5.0",
    "@progress/kendo-theme-material": "~14.5.0",
    "@progress/kendo-theme-utils": "~14.5.0",
    "apollo-angular": "^14.1.0",
    "apollo-upload-client": "^19.0.0",
    "date-fns": "~4.4.0",
    "echarts": "~6.1.0",
    "exifr": "~7.1.3",
    "graphql": "~17.0.2",
    "hammerjs": "~2.0.8",
    "localforage": "~1.10.0",
    "mapbox-gl": "~3.31.0",
    "material-symbols": "~0.45.6",
    "monaco-editor": "~0.57.0",
    "moo": "~0.5.2",
    "ngrx-store-localstorage": "^20.1.0",
    "ngx-monaco-editor-v2": "~22.0.5",
    "ngx-pipes": "~3.2.2",
    "ngx-quill": "~31.0.1",
    "normalize-url": "~9.0.1",
    "object-hash": "~3.0.0",
    "powerbi-client": "~2.25.0",
    "powerbi-client-angular": "~6.0.3",
    "proj4": "~2.20.2",
    "quill": "npm:quill-next@~2.2.6",
    "rete": "^2.0.6",
    "rete-angular-plugin": "~2.7.1",
    "rete-area-plugin": "^2.1.5",
    "rete-connection-plugin": "^2.0.5",
    "rete-context-menu-plugin": "^2.0.6",
    "rete-render-utils": "^2.0.3",
    "rxjs": "~7.8.1",
    "tslib": "^2.6.3",
    "uuid": "~14.0.2",
    "zone.js": "~0.16.3"
  },
  "devDependencies": {
    "@angular-builders/jest": "22.0.1",
    "@angular-devkit/architect": "^0.2202.0",
    "@angular-devkit/build-angular": "^22.2.0",
    "@angular-devkit/core": "^22.2.0",
    "@angular-devkit/schematics": "^22.2.0",
    "@angular-eslint/eslint-plugin": "~22.5.0",
    "@angular-eslint/eslint-plugin-template": "~22.5.0",
    "@angular-eslint/template-parser": "22.5.0",
    "@angular/animations": "^22.2.0",
    "@angular/build": "^22.2.0",
    "@angular/cli": "^22.2.0",
    "@angular/compiler-cli": "^22.2.0",
    "@compodoc/compodoc": "~2.0.0",
    "@egjs/hammerjs": "^2.0.0",
    "@eslint/js": "~10.0.1",
    "@happy-dom/jest-environment": "~20.14.5",
    "@rspack/core": "~1.7.1",
    "@rushstack/eslint-config": "~4.8.0",
    "@schematics/angular": "^22.2.0",
    "@types/jest": "~30.0.0",
    "@types/node": "~26.6.3",
    "@types/proj4": "~2.19.0",
    "@typescript-eslint/eslint-plugin": "~8.71.0",
    "@typescript-eslint/parser": "~8.71.0",
    "angular-eslint": "~22.5.0",
    "eslint": "~10.11.0",
    "eslint-plugin-autofix": "~2.2.0",
    "eslint-plugin-import": "~2.32.0",
    "hono": "^4.13.10",
    "jest": "~30.5.2",
    "jest-environment-jsdom": "~30.4.1",
    "jest-junit": "~17.0.0",
    "jest-preset-angular": "~17.0.1",
    "jest-slow-test-reporter": "~1.0.0",
    "jsdom": "~29.1.1",
    "prettier": "^3.9.9",
    "ts-node": "~10.9.2",
    "typescript": "~6.0.3",
    "typescript-eslint": "~8.71.0"
  }
}
